import en from './en';
import no from './no';

export default {
  en,
  no,
};



// WEBPACK FOOTER //
// ./src/app/locale/index.js